/**
 * Class used to enforce definitionName property on definition constants.
 */
class DefinitionConstant extends Object {
    definitionName: string;
    // [key: string]: string;
}

/**
 * Freezes the object.
 * Note: Using generics to copy inferred typings to the target.
 * @param obj - A plain object
 */
function createDefinitionConstant<T extends DefinitionConstant>(obj: T): Readonly<T> {
    return Object.freeze(obj);
}

export const Asset = createDefinitionConstant({
    definitionName: "M.Asset",

    // Properties
    title: "Title",
    fileName: "FileName",
    description: "Description",
    renditions: "Renditions",
    extraRenditions: "ExtraRenditions",

    // Relations
    finalLifeCycleStatusToAsset: "FinalLifeCycleStatusToAsset",
});

export const File = createDefinitionConstant({
    definitionName: "M.File",
});

export const Setting = createDefinitionConstant({
    definitionName: "M.Setting",

    // Properties
    name: "M.Setting.Name",
    value: "M.Setting.Value",
    schema: "M.Setting.Schema",
    label: "M.Setting.Label",

    // Relations
    settingCategoryToSettings: "SettingCategoryToSettings",

    // Instances
    CultureSetting: Object.freeze({
        name: "Cultures",
    }),
});

export const MailTemplate = createDefinitionConstant({
    definitionName: "M.Mailing.Template",
});

export const User = createDefinitionConstant({
    definitionName: "User",

    // Properties
    username: "Username",
    lockoutEndDate: "LockoutEndDate",
    accessFailedCount: "AccessFailedCount",
    lastPasswordChangeDateTime: "LastPasswordChangeDateTime",
    emailConfirmationPending: "EmailConfirmationPending",
    lastLoginDateTime: "LastLoginDateTime",
    userGroupConfiguration: "UserGroupConfiguration",

    // Relations
    userGroupToUser: "UserGroupToUser",
    userToUserProfile: "UserToUserProfile",
});

export const UserProfile = createDefinitionConstant({
    definitionName: "M.UserProfile",
});

export const UserGroup = createDefinitionConstant({
    definitionName: "UserGroup",

    // Properties
    groupName: "GroupName",

    Groups: Object.freeze({
        everyone: "Everyone",
        superusers: "Superusers",
    }),
});

export const FinalLifeCycleStatus = createDefinitionConstant({
    definitionName: "M.Final.LifeCycle.Status",

    // Properties
    statusValue: "StatusValue",

    StatusValues: Object.freeze({
        created: "Created",
        approved: "Approved",
        rejected: "Rejected",
        archived: "Archived",
        underReview: "UnderReview",
    }),
});

export const SettingsCategory = createDefinitionConstant({
    definitionName: "M.SettingCategory",

    // Properties
    name: "M.SettingCategory.Name",
});

export const PublicLink = createDefinitionConstant({
    definitionName: "M.PublicLink",

    // Properties
    conversionConfiguration: "ConversionConfiguration",
    expirationDate: "ExpirationDate",
    relativeUrl: "RelativeUrl",
    resource: "resource",

    // Relations
    assetToPublicLink: "AssetToPublicLink",
});
